class SalesRegisterModel {
  SalesRegisterId = null;
  EnquiryId = null;
  SalesDate = '';
  CustomerName = '';
  MobileNumber = '';
  EmailId = '';
  Remarks = '';
  AdvancePayment = '';
  DiscountAmount = '';
  SalesRegisterDetails = [];
}

export default SalesRegisterModel;
